import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { getClaimStatus } from "../api/ClaimAPI";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnTypeClaimStatus = typeof getClaimStatus;

export const useClaimStatus = (config?: QueryConfig<QueryFnTypeClaimStatus>) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser ?? false);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByCurrentUser: filterByUser,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeClaimStatus>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["claimStatus", filterByUser, filters, currentUser],
        queryFn: () => getClaimStatus(paginationFilters), 
    });
}